const SELECTOR = ':is([data-ch-lazy-module-src], [data-ch-lazy-module-srcs]):not([data-ch-lazy-module-loaded])';
const DEFAULT_ROOT_MARGIN = '600px 0px';

const observers = new Map();

function normalizeSource(src) {
  return src.startsWith('//') ? `${window.location.protocol}${src}` : src;
}

function readSources(element) {
  if (!(element instanceof HTMLElement)) return [];

  const srcs = element.dataset.chLazyModuleSrcs;
  if (srcs) {
    try {
      const parsed = JSON.parse(srcs);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return srcs.split(',').map((src) => src.trim()).filter(Boolean);
    }
  }

  return element.dataset.chLazyModuleSrc ? [element.dataset.chLazyModuleSrc] : [];
}

async function loadModule(element) {
  if (!(element instanceof HTMLElement) || element.dataset.chLazyModuleLoaded === 'true') return;

  const sources = readSources(element);
  if (!sources.length) return;

  element.dataset.chLazyModuleLoaded = 'true';

  sources
    .reduce((chain, src) => chain.then(() => import(normalizeSource(src))), Promise.resolve())
    .then(() => {
      element.dispatchEvent(new CustomEvent('ch-lazy-module:loaded', { bubbles: true, detail: { sources } }));
    })
    .catch((error) => {
      element.dataset.chLazyModuleLoaded = 'error';
      console.warn('CH lazy module failed to load.', sources, error);
    });
}

function getObserver(rootMargin) {
  if (observers.has(rootMargin)) return observers.get(rootMargin);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        loadModule(entry.target);
      });
    },
    { rootMargin },
  );

  observers.set(rootMargin, observer);
  return observer;
}

function observeLazyModules(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach((element) => {
    if (!(element instanceof HTMLElement)) return;

    if (!('IntersectionObserver' in window)) {
      loadModule(element);
      return;
    }

    const rootMargin = element.dataset.chLazyRootMargin || DEFAULT_ROOT_MARGIN;
    getObserver(rootMargin).observe(element);
  });
}

if (document.readyState === 'loading') {
  observeLazyModules();
  document.addEventListener('DOMContentLoaded', () => observeLazyModules(), { once: true });
} else {
  observeLazyModules();
}

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  observeLazyModules(event.target);
});
